import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function LokacijaIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="LokacijaIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <rect fill="currentcolor" fillRule="evenodd" clipRule="evenodd" x="36.5" y="70.001" width="27" height="4.7"/>
      <path fill="currentcolor" d="M61.735,29.972c-3.378-3.115-7.29-4.673-11.735-4.673c-4.446,0-8.358,1.558-11.735,4.673
        c-3.378,3.115-5.066,7.298-5.066,12.549c0,3.5,1.391,7.307,4.174,11.42C40.155,58.054,50,70.001,50,70.001
        s9.844-11.948,12.627-16.061c2.783-4.113,4.175-7.919,4.175-11.42C66.802,37.27,65.112,33.087,61.735,29.972z M50,46.3
        c-2.32,0-4.2-1.88-4.2-4.2s1.88-4.2,4.2-4.2s4.2,1.88,4.2,4.2S52.319,46.3,50,46.3z"/>
    </svg>
  </SvgIcon>
}

export default LokacijaIcon;
